import clsx from 'clsx';
import React, { type PropsWithChildren, type ReactNode } from 'react';

type DetailFieldProps = {
  label: ReactNode;
  valueSize?: 'md' | 'lg';
  className?: string;
  padding?: boolean;
  disableBorder?: boolean;
};

export const DetailField = ({
  label,
  valueSize = 'md',
  children,
  className,
  padding = true,
  disableBorder = false,
}: PropsWithChildren<DetailFieldProps>): JSX.Element => (
  <div
    className={clsx(
      'flex',
      'border-main-300',
      !disableBorder && 'border-b-[0.5px]',
      'first:border-t-[0.5px]',
      !disableBorder && 'border-l-[0.5px]',
      !disableBorder && 'border-r-[0.5px]',
      className
    )}
  >
    {/* Label column */}
    <div
      className={clsx(
        !disableBorder && 'border-r-[0.5px]',
        'border-main-300',
        'flex items-start',
        'p-f1',
        'w-[229px]',
        'text-md text-main'
      )}
    >
      {label}
    </div>

    {/* Value column */}
    <div className={clsx('flex items-start', 'flex-1', padding && 'p-f1')}>
      {children}
    </div>
  </div>
);
